import { Box } from "@/components/layout/flexbox";
import LedgerAccountSelector from "@/components/pieces/products/LedgerAccountSelector";
import { MIDTEXT_COLOR } from "@/css/constants";

export default function CreditDestination({
  ledgerAccounts,
  ledgerAccountId,
  setLedgerAccountId,
}) {
  return (
    <Box
      className="bas round-corners"
      backgroundColor="#FFF"
      pt={24}
      pb={3}
      px={[3, 24]}
    >
      <Box fontSize={22} fontWeight={600} mb={1}>
        Choose credit account
      </Box>
      <Box mb={24} color={MIDTEXT_COLOR}>
        Purchased credits will be deposited into the selected account
      </Box>
      <LedgerAccountSelector
        ledgerAccounts={ledgerAccounts}
        ledgerAccountId={ledgerAccountId}
        onSelectAccountId={setLedgerAccountId}
      />
    </Box>
  );
}
